<template>
    <div :class="[avecImage ? 'd-flex align-items-center flex-column cadre' : '']" class="mb-2">
        <img v-if="avecImage" :src="'images/Photos/Appli/'+cheminImage+'/'+libelle+'.png'" class="w-100"
            @click="$emit('change', {type:type,libelle:libelle,complement:complement,selected:selected})">
        <input type="checkbox" class="form-check-input" :id="type+libelle" :name="type+libelle" :value="type+libelle"
            @change="$emit('change', {type:type,libelle:libelle,complement:complement,selected:selected})"
            :ref="type.libelle" :class="[avecImage ? 'd-none' : '']">
        <label class="form-check-label" :for="type+libelle"
            :class="[avecImage ? 'miniFont text-center text-dark' : 'pl-4']">{{libelle}}</label>
    </div>
</template>

<script>
    export default {
        name: 'FormCheck',

        props: {
            type: String,
            libelle: String,
            complement: String,
            selected: Boolean,
            avecImage: {
                type: Boolean,
                default: false,
            },
            cheminImage: {
                type: String,
                default: "",
            }
        },
        data() {
            return {}
        },

        computed: {
            // select: {
            //   get() {
            //   return this.selected
            // },
            // // setter
            // set(newValue) {
            //   this.selected = newValue
            // }
            // }
        },

        mounted() {

        }
    }

</script>

<style scoped>
    .miniFont {
        font-size: 10pt;
        font-family: 'Roboto', sans-serif;
    }

    .cadre {
        cursor: pointer !important;
    }

    .form-check-label {
        letter-spacing: -0.5px;
    }

</style>
